/* eslint-disable no-useless-constructor */
import FieldModel from './FieldModel';
import { NumberInput } from '../inputs';

class NumberField extends FieldModel {
  /**
   * @param {Object} params
   * @param {string} params.kWord Unique object key (from plans)
   * @param {string} params.label Input label, used on the field filter
   * @param {boolean} [params.required] If the input is required (not empty)
   * @param {boolean} [params.removed] Condition to not render and use this field
   * @param {boolean} [params.disabled] Condition to block this field (still visible)
   * @param {any} [params.default] Default (initial) value
   * @param {boolean} [params.money] If the number is money (adds R$)
   * @param {number} [params.min] Minimum number value
   * @param {number} [params.max] Maximum number value
   * @param {number} [params.step] Value step on the buttons
   * @param {number} [params.precision] Number of decimal cases
   */
  constructor(params) {
    super(params);
  }

  getDefaultState = () => ({
    value: this.default ?? this.min,
    error: Boolean(this.required),
    errorMsg: this.required ? 'Informe um valor válido' : '',
  });

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (value) => handle({
      [this.kWord]: {
        value: +(value),
        error: false,
        errorMsg: '',
      },
    });
    return (
      <NumberInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
        min={this.min}
        max={this.max}
        step={this.step}
        precision={this.precision}
        isMoney={this.money}
      />
    );
  }
}

export default NumberField;
